module.exports = __webpack_public_path__ + "static/media/notFound.15ffdca4.png";